import React from 'react'
import CYBRSCRTYBNR from "../../assets/Graphics/CyberInfoGraphic.png";

const WebDarkMonitor = () => {
    const DARK_WEB_MONITORING = [
        {
          id: 1,
          title: "Detect: ",
          descp:
            "Tracks compromised credentials from the dark web and known breaches. ",
        },
        {
          id: 2,
          title: "Alert: ",
          descp: "Sends real-time alerts when your data is exposed. ",
        },
        {
          id: 3,
          title: "Resolve: ",
          descp:
            "Offers step-by-step guidance to secure your accounts immediately.",
        },
        {
          id: 4,
          title: "Monitor: ",
          descp:
            "Soon supports multiple email IDs, with upcoming features to track credit cards, government IDs, and more. ",
        },
      ];    
  return (
    <>
      {/* ****** Dark Web Monitoring ****** */}
      <div className="bg-white py-8">
        <div className="max-w-screen-lg mx-auto px-4">
          <div className="text-center mb-4">
            <h3 className="main-heading-font-size  mb-2">
              Dark Web Monitoring - Know When You’re Exposed—Before It’s Too
              Late.
            </h3>
            <p className="text-base text-gray-700 max-w-2xl mx-auto">
              Our Dark Web Monitoring system actively scans hidden forums,
              breach databases, and malicious networks using your registered
              email(s).
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mt-8">
            <div className="flex-1 w-full md:w-1/2">
              {DARK_WEB_MONITORING.map((step) => (
                <div key={step.id} className="flex items-start mb-4">
                  <div className="flex-shrink-0">
                    <div
                      className="flex items-center justify-center rounded-full"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        width: 28,
                        height: 28,
                        fontFamily: '"Poppins", serif',
                        fontSize: "1rem",
                        marginRight: "1rem",
                        marginTop: "0.25rem",
                      }}
                    >
                      {step.id}
                    </div>
                  </div>
                  <div>
                    <span className="font-semibold">{step.title}</span>
                    <span>{step.descp}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex-1 w-full md:w-1/2 flex items-center justify-center">
              {/* You can replace the src below with your actual image asset */}
              <img
                src={CYBRSCRTYBNR}
                alt="Cyber Security Illustration"
                className="w-full max-w-xs md:max-w-md object-contain"
                style={{ maxHeight: 300 }}
              />
            </div>
          </div>
          <div className="text-center mt-8">
            <div className="inline-block bg-gray-100 rounded px-4 py-2">
              <span className="text-sm text-gray-700">
                Powered by{" "}
                <b style={{ color: "#000" }}>Fraud Lab &amp; Seqrite Labs</b>,
                this feature keeps you one step ahead of hackers and data leaks.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WebDarkMonitor
